import { IPurchaseCostCenter } from "../../types/purchaseCostCenter";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";

const API_URL = import.meta.env.VITE_API_URL;

const makeRequestDebounced = createDebounce(makeRequest, 200);

export type CostCenterApi = {
  description: string;
  categoriesId: never[];
};

export async function createCostCenter(data: CostCenterApi) {
  const url = `${API_URL}/purchase-cost-center`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  const result = makeRequestDebounced(url, options) as Promise<
    ApiResponseType<IPurchaseCostCenter>
  >;

  return result;
}

export async function updateCostCenter(data: IPurchaseCostCenter) {
  const url = `${API_URL}/purchase-cost-center`;
  const options = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  const result = makeRequestDebounced(url, options) as Promise<
    ApiResponseType<IPurchaseCostCenter>
  >;
  return result;
}

export async function getCostCenterById(id: string) {
  const url = `${API_URL}/purchase-cost-center/${id}`;
  return (await makeRequestDebounced(
    url
  )) as ApiResponseType<IPurchaseCostCenter>;
}

type GetCategoriesOptions = {
  status?: string[];
  search?: string;
  page?: number;
  itemsPerPage?: string;
  orderBy?: string;
  fields?: string;
};

export async function getCostCenters(options: GetCategoriesOptions = {}) {
  const {
    status = [],
    search = "",
    page = 1,
    itemsPerPage = "10",
    orderBy = "updatedAt",
    fields = "name,type,idNibo",
  } = options;
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
    fields,
  });
  let statusParam = "";
  if (Array.isArray(status) && status.length > 0) {
    statusParam = status.join(",");
  } else if (typeof status === "string") {
    statusParam = status;
  }
  status && params.append("filters[status]", statusParam);
  search && params.append("search", search);
  orderBy && params.append("orderBy", orderBy);

  const url = `${API_URL}/purchase-cost-center?${params.toString()}`;
  const result = (await makeRequestDebounced(url)) as ApiResponseType<
    IPurchaseCostCenter[]
  > & { totalItems: number };

  return { ok: result.ok, data: result.data, totalItems: result.totalItems };
}
